export const busca = {
  title: 'Busca',
  description: 'Encontre trilhas, cursos e aulas publicados na plataforma.',
  placeholder: 'Buscar trilhas, cursos e aulas…',
  prompt: {
    title: 'Digite para buscar',
    description: 'A busca cobre o conteúdo publicado da plataforma.',
  },
  semResultado: {
    title: 'Nenhum resultado',
    description: 'Verifique a grafia ou tente outro termo.',
  },
  tipo: {
    trilha: 'Trilha',
    curso: 'Curso',
    aula: 'Aula',
  },
} as const;
